module.exports = __webpack_public_path__ + "img/brief_icon_caichan.93a222e4.png";